/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { OutlinedButton, ContainedButton } from '../index';
import { Box } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

export const ProfileButtons = (props) => {
  return (
    <Box sx={{ ml: 'auto', mr: 3 }}>
      {props.editMode ? (
        <OutlinedButton btnTitle="Edit Profile" onClick={props.handleEdit} />
      ) : (
        <Box>
          <OutlinedButton
            style={{ width: 110 }}
            btnTitle="Cancel"
            onClick={props.handleCancel}
          />
          <ContainedButton
            btnTitle="Save"
            startIcon={<SaveIcon />}
            onClick={props.handleSave}
            style={{ width: 110, ml: 2 }}
            disabled={props.disabledSave}
          />
        </Box>
      )}
    </Box>
  );
};
